import { Checkbox, FormControlLabel, Stack, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Icon } from '@iconify/react';
import humanize from 'humanize';
import roundWarning from '@iconify/icons-ic/round-warning';
import roundCheckCircle from '@iconify/icons-ic/round-check-circle';
const ViolatedPolicies = ({ policies, bypassedPolicies, onBypassPolicy, viewOnly }) => {
  const theme = useTheme();
  if (policies.length === 0)
    return (
      <Stack justifyContent={'center'} alignItems={'center'} width={'100%'} height={'100%'}>
        <Icon
          icon={roundCheckCircle}
          color={theme.palette.success.dark}
          fontSize={theme.spacing(8)}
        />
        <Typography variant="h4" color={'success.dark'}>
          No Violated Policies
        </Typography>
      </Stack>
    );
  return (
    <Stack style={{ padding: '10px 5px' }}>
      <div style={{ marginBottom: theme.spacing(1) }}>
        <Stack alignItems={'center'} gap={1} direction={'row'}>
          <Icon icon={roundWarning} color={theme.palette.error.main} fontSize={theme.spacing(4)} />
          <Typography variant="h4">Violated Policies</Typography>
          <Typography variant="subtitle1" color="textSecondary">
            ({humanize.numberFormat(policies.length, 0)})
          </Typography>
        </Stack>
        <Typography variant="subtitle2" color="textSecondary">
          {!viewOnly
            ? 'By checking the boxes below, you agree to bypass the policies that are violated by this request'
            : 'You can only view the violated policies'}
        </Typography>
      </div>

      <div
        style={{
          padding: ' 0px ' + theme.spacing(1),
          overflowY: 'scroll',
          maxHeight: theme.spacing(30)
        }}
      >
        {policies.map((policy) => (
          <div style={{ marginBottom: theme.spacing(1) }} key={policy.id}>
            <Stack
              key={policy.id}
              alignItems={'center'}
              direction={'row'}
              justifyContent={'space-between'}
              gap={2}
            >
              <Typography variant="h5" color="error">
                {policy.name}
              </Typography>
              {!viewOnly && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={bypassedPolicies.find(
                        (bypassedPolicy) => bypassedPolicy.id === policy.id
                      )}
                      onChange={() => {
                        onBypassPolicy(policy);
                      }}
                      name={`policy-${policy.name.toLowerCase().replace(' ', '_')}`}
                      color={'error'}
                      disabled={viewOnly}
                    />
                  }
                  label=""
                />
              )}
            </Stack>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              style={{ marginLeft: '5px', marginTop: '-10px' }}
            >
              {policy.reason}
            </Typography>
          </div>
        ))}
      </div>
    </Stack>
  );
};

export default ViolatedPolicies;
